const featureFlags = {
  // ==========================================
  // Application Core & Infrastructure
  // ==========================================
  // Version management and update control
  herbieDashboardVersion: '0.0.1',
  forceUpdateVersionDashboard: false,

  // Early Access
  userEarlyAccess: false,

  // UI components and navigation
  sidebar: false,
  toggleFeatureFlag: false,
  sidebarIncidents: false,

  // PostHog kill switch: flip to false in LaunchDarkly to stop loading the
  // posthog-js SDK on new sessions (no identify, no survey fetch, no captures).
  posthogEnabled: true,

  // Developer and debugging tools
  developerTools: false,
  cobler: false,
  impersonate: false,

  // ==========================================
  // Monitoring & Device Tracking
  // ==========================================
  // Device monitoring and status
  activityCompletionStatus: false,
  devicesSlideSseTimeInMs: 10100,
  idleTime: true,
  /**
   * LaunchDarkly key: `monitoring-v2` — mapa vetorial do monitoramento em paralelo ao clássico. Ligada, o
   * `/monitoring` oferece a escolha de versão; o padrão desligado deixa o clássico se o LD não responder.
   */
  monitoringV2: false,
  /**
   * LaunchDarkly key: `monitoring-v2-as-default` — com `monitoringV2`, o primeiro acesso ao `/monitoring` vai
   * direto para a V2 em vez da escolha de versão. Só decide o primeiro acesso: grava `v2` como preferência e,
   * se o cliente voltar para o clássico, a escolha dele vale dali em diante.
   */
  monitoringV2AsDefault: false,
  removedDevice: false,
  showDeviceObservation: false,
  trackingForceVisibilityGeofence: false,
  /** LaunchDarkly key: `tracking-v2` — nova experiência de replay dedicado e histórico V2 */
  trackingV2: false,

  // ==========================================
  // Fleet Management
  // ==========================================

  sheetImportWithAi: false,

  /** LaunchDarkly key: `operational-health-card` — card "Saúde da operação" na home ongoing */
  operationalHealthCard: false,

  // Fleet events and tracking
  enableFleetEvents: false,
  enableV2FleetEvents: false,
  libraryExtensionEventSource: false,

  // Driver management and identification
  driverIdentification: false,
  driverSuggestion: false,
  enableDriverAssociationPast: false,
  identifierAssociations: false,
  clusterPhotoSuggestions: false,
  /** LaunchDarkly key: `face-id-v-1` — gates the Face ID V1 experience (overview/running-without-driver
   * tabs). When off, the vehicles and drivers pages show only their plain lists, with no tab bar. */
  faceIdV1: false,
  /** LaunchDarkly key: `driver-identification-method-qrcode` — gates the "QR Code" option in the
   * association source filter (path-association and camera events pages) to pilot fleets only. */
  driverIdentificationMethodQrcode: false,

  // Vehicle and driver allow lists
  allowList: false,
  enableVehicleDriverAllowList: false,

  // ==========================================
  // Media & Video Features
  // ==========================================
  // Livestream functionality
  livestream: false,
  livestreamPage: false,
  livestreamMulti: false,
  disableLivestreamTimeRestriction: false,
  livestreamConfig: {
    liveTimeout: 60,
    bannerTimeout: 30,
    bannerThreshold: 5,
  },

  /** LaunchDarkly key: `voice-chat` — gates the "Conversar" (voice chat) button in the vehicle
   * popup, next to the livestream button. V1: connection flow only, no audio (pooler phase 4). */
  voiceChat: false,

  // Video playback and events
  videoImpactEvent: false,
  /** LaunchDarkly key: `camera-streamax-new-events` — per-fleet gate for the Streamax (Gen4) event
   * types in `STREAMAX_CAMERA_EVENT_TRIGGERS`. Default OFF: they stay out of every event list and
   * filter. */
  cameraStreamaxNewEvents: false,
  /** LaunchDarkly key: `camera-split-collision-events` — apresenta Aviso de Colisão Frontal e
   * Distância Insegura como dois eventos distintos (rótulo próprio + opção própria de filtro), em
   * vez do rótulo único "Distância insegura". Governa apresentação, nunca volume: com a flag ligada
   * FRONT_COLLISION_WARNING entra nos triggers padrão no mesmo movimento em que a expansão sai do
   * api-lib, então a visão default traz o mesmo conjunto de eventos ligada ou desligada (ADR 0018).
   * Default OFF. */
  cameraSplitCollisionEvents: false,
  /** LaunchDarkly key: `camera-streamax-occupancy-config` — linha de Ocupação (liga/desliga, sensibilidade e
   * limite de pessoas) no card DMS da configuração de eventos, só para frotas com Streamax. Default OFF. */
  cameraStreamaxOccupancyConfig: false,
  mediaEventLiveUpdate: false,
  videoEnhancedFeatures: false,
  cobliCamAiOverlay: false,
  /** LaunchDarkly key: `cobli-cam-ai-overlay-3d` — abas "Aceleração 3D" e "Proximidade 3D" na telemetria
   * do player de IA (veículo 3D e narração por evento, ADR 0017/0018), ao lado das abas clássicas. */
  cobliCamAiOverlay3d: false,
  /** LaunchDarkly key: `media-export-anonymize` — item "Anonimizar e baixar…" no menu de download dos players,
   * com a Exportação anonimizada no navegador (ADR 0031). Default OFF: o menu segue só com o Download original. */
  mediaExportAnonymize: false,
  videoEventSeverity: false,
  showObstructionDashboard: false,
  showMatchReview: false,
  multiCamVideoRequests: false,
  multiCamTimelapseRequests: false,
  cobliCamProRecordOff: true,
  /** LaunchDarkly key: `video-request-communication` — nova comunicação da página de vídeos solicitados:
   * colunas, estado de espera na coluna de status, "Como o vídeo é enviado" e tela de sucesso da
   * solicitação. Default OFF: a página segue como está no master. */
  videoRequestCommunication: false,
  /** LaunchDarkly key: `multi-timezone-communication` — gate do anúncio (Prismic `announcement_card`) da
   * correção de fuso nos vídeos solicitados da Cobli Cam Multi. Default OFF. */
  multiTimezoneCommunication: false,

  // Video configuration
  disableWifiConfiguration: false,
  enforceCameraFeatures: false,

  // AI-powered
  aiChat: false,
  /** LaunchDarkly key: `ai-usage-meter`; rollout keeps the indicator and local notices off until reconciliation. */
  aiUsageMeter: false,
  aiChecklist: false,
  /** LaunchDarkly key: `ai-config` — libera a página de configurações da Cobli IA (`/ai/config`) */
  aiConfig: false,
  aiAnalyzeTrackingButton: false,
  aiVideosRecommendations: false,
  aiFilterAnnouncement: false,
  importIdentifierAi: false,
  /** LaunchDarkly key: `identification-token-inverted-byte-format` — controls byte-order display for fleets using Orbital readers */
  identificationTokenInvertedByteFormat: false,
  aiUserModalUpdate: false,
  /** LaunchDarkly key: `ai-composio` — libera os conectores Composio (Gmail, Drive, Planilhas) no composer do chat */
  aiComposio: false,
  /** LaunchDarkly key: `orders-ai-page` — página dedicada do agente de agendamentos em /orders/ai (experimento de descoberta) */
  ordersAiPage: false,
  /** LaunchDarkly key: `ai-guided-tour` — botão "Me mostre como": a Cobli IA navega, abre telas e toca um tour guiado pela pergunta do usuário */
  aiGuidedTour: false,

  // ==========================================
  // AI Recommendations
  // ==========================================
  aiRecommendations: false,
  aiRecommendations2: false,
  poisRecommendations: false,
  aiGroupRecommendations: false,
  /** LaunchDarkly key: `blueprint-checklist-non-compliance-enabled` — libera as sugestões do alerta de checklist com não conformidade (banner, pós-save e card) */
  blueprintChecklistNonComplianceEnabled: false,
  /** LaunchDarkly key: `home-action-modal-speed-limit` — multivariada; `off` mantém fora do A/B quem o LD não avaliou */
  homeActionModalSpeedLimit: 'off',
  /** LaunchDarkly key: `home-action-modal-fleet-policy` — multivariada; `off` mantém fora do A/B quem o LD não avaliou */
  homeActionModalFleetPolicy: 'off',
  /** LaunchDarkly key: `checklist-compliance-floating-card` — `true` para frota sem checklist (segmento vindo do Snowflake), `false` para frota com checklist */
  checklistComplianceFloatingCard: false,
  /** LaunchDarkly key: `checklist-non-conformity-queue` — libera a aba Tratativas (fila de itens não conformes) em Checklists */
  checklistNonConformityQueue: false,

  // Audio features
  vehiclePopupAudioButton: false,

  // ==========================================
  // Analytics & Reporting
  // ==========================================
  // Fuel card: which partner a fleet uses comes from `GET /fuel/integrations`, not from a flag.
  fuelCardManual: false,
  enableBrokenFuelCardIntegrationBanner: false,

  // Fuel AI research
  researchFuelAI: false,
  aiFuelOcr: false,

  // Reports and analytics
  showIncidentsReport: false,
  /** LaunchDarkly key: `query-builder-report` — construtor de consultas sobre a analytics-query-api. */
  queryBuilderReport: false,
  coblinator: false,
  safetyRankingDash: false,
  /** LaunchDarkly key: `app-safety-ranking` — ranking de condução no app do Gestor (AE-2693).
   * No painel, gate do modal de divulgação na página do ranking e do comunicado no Prismic. */
  appSafetyRanking: false,

  // ==========================================
  // Pages & Features
  // ==========================================
  // Navigation pages
  heavyUserMap: false,
  roadSpeedPage: true,
  expensesImportButton: true,
  finesPage: false,
  deviceConfigWebhook: false,
  businessManager: true,
  assetTagFleets: false,

  // Feature-specific pages
  maintenance: false,
  /** LaunchDarkly key: `maintenance-situation-bridge` — sugestões entre manutenção e situação operacional; público é lista curada de fleet ids no LD (AE-2785) */
  maintenanceSituationBridge: false,
  canUseNonAssociatedVehiclesToRegisterMaintenanceAndTransaction: false,
  prismicAlertsNotAdoptedCohort: false,
  /** LaunchDarkly keys: `prismic-<tema>-communication` — gates das novidades e anúncios do Prismic sobre
   * grupos de veículos, locais de interesse, usuários, alertas e limite de velocidade. Default OFF. */
  prismicGroupsCommunication: false,
  prismicGeofencesCommunication: false,
  prismicUsersCommunication: false,
  prismicFleetPolicyCommunication: false,
  prismicSpeedLimitCommunication: false,

  // ==========================================
  // Account & User Experience
  // ==========================================
  // Account configuration
  ongoingActivationTasks: false,
  announcementCard: false,
  usersNovosAi: false,

  // Contract renewal popup
  contractRenewalConfig: false,

  // Basic Value guided onboarding modal (LaunchDarkly key: basic-value-onboarding)
  basicValueOnboarding: false,

  // ==========================================
  // IoT & Device Control
  // ==========================================
  // Vehicle immobilizer
  enableImmobilizer: false,
  vehicleImmobilizer: false,

  // Remote connection
  useRemoteConnection: false,

  /** LaunchDarkly key: `sound-alerts-v-2` — gates the revamped Avisos Sonoros page
   * (`/config/alerts`): full-width vehicle table with the standard filters and sync status, and a
   * side drawer that configures one vehicle or the whole selection. Default OFF keeps the current
   * accordion page (`AlertSettings`) untouched, so rollback is a flag flip.
   * See docs/adr/0016-avisos-sonoros-sem-heranca-e-provisorio.md. */
  soundAlertsV2: false,

  // ==========================================
  // Integrations & External Services
  // ==========================================
  // Address and location services
  internationalAddressAutocomplete: false,

  // Autocomplete de endereço self-hosted (OSM). LaunchDarkly key:
  // `osm-autocomplete-enabled`. Por fleet — fora da flag, Google Places.
  osmAutocompleteEnabled: false,

  // Communication services
  // NOTE: keep the catalog key as `blipChat` because that's the LaunchDarkly
  // flag name that gates Intercom. The implementation is Intercom; only the
  // flag key is legacy.
  blipChat: false,

  // ==========================================
  // Development & Monitoring Tools
  // ==========================================
  // Datadog RUM (Real User Monitoring)
  ddRumSampleRate: 100,
  ddRumReplaySampleRate: 0,
  // Browser profiling (flame graph das long tasks). LaunchDarkly key: `dd-rum-profiling-sample-rate`.
  // Percentual das sessões já amostradas; só coleta com o header `Document-Policy: js-profiling` no HTML.
  ddRumProfilingSampleRate: 0,
  useDdRum: false,

  // Push notifications
  oneSignal: false,

  // Temporary flags
  showWarningBanner: false,

  // Resumo de Alertas (Bulletin) — LaunchDarkly key: `blueprint-bulletin-enabled`.
  // Shared gate with the Blueprint SDUI stack so a single flag toggles the feature on
  // both the legacy and Blueprint alert forms. See `TriggerBulletinConfig` in modules/triggers.
  blueprintBulletinEnabled: false,
};

type FeatureFlags = typeof featureFlags;

export { featureFlags };
export default FeatureFlags;
